<template>
  <div class="right-panel">
    <!-- ==================== 每月数据统计模块 ==================== -->
    <div class="panel-item monthly-panel">
      <div class="panel-box">
        <div class="panel-content">
          <!-- 标题栏 + 切换标签 -->
          <div class="panel-header">
            <div class="panel-title">每月数据统计</div>
            <div class="panel-tabs">
              <span 
                class="tab" 
                :class="{ active: monthlyChartType === 'participant' }"
                @click="switchMonthlyChartType('participant')"
              >参赛人数</span>
              <span 
                class="tab" 
                :class="{ active: monthlyChartType === 'attention' }"
                @click="switchMonthlyChartType('attention')"
              >关注人次</span>
            </div>
          </div>
          
          <!-- 分割线 -->
          <div class="divider-line"></div>
          
          <!-- 折线图容器 -->
          <div id="lineChart" class="chart-container"></div>
          
          <!-- 最新报名标题 -->
          <div class="section-title">最新报名</div>
          
          <!-- DataV 轮播表格 -->
          <div class="scroll-table">
            <dv-scroll-board :config="scrollBoardConfig" style="width:100%;height:70px" />
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 人群占比模块 ==================== -->
    <div class="panel-item crowd-panel">
      <div class="panel-box">
        <div class="panel-content">
          <!-- 标题栏 + 切换标签 -->
          <div class="panel-header">
            <div class="panel-title">人群占比</div>
            <div class="panel-tabs">
              <span class="tab active">参赛人数</span>
            </div>
          </div>
          
          <!-- 分割线 -->
          <div class="divider-line"></div>
          
          <!-- 人群占比饼图容器 -->
          <div id="crowdChart" class="chart-container crowd-chart-container"></div>
          
          <!-- 人群信息展示区 (轮播卡片) -->
          <div class="crowd-info" v-if="crowdData && crowdData.length > 0">
            <div class="carousel-wrapper">
              <div class="carousel-arrow left" @click="prevCrowd">&nbsp;</div>
              <transition name="slide-fade" mode="out-in">
                <div class="info-card" :key="currentCrowdIndex">
                  <div class="info-icon">
                    <img src="@/assets/images/使用工具生成图片 (-1.png" alt="人群图标" />
                  </div>
                  <div class="info-text">
                    <div class="info-label">{{ crowdData[currentCrowdIndex].label }} {{ crowdData[currentCrowdIndex].age }}</div>
                    <div class="info-value">参赛人数：{{ crowdData[currentCrowdIndex].count.toLocaleString() }}</div>
                  </div>
                </div>
              </transition>
              <div class="carousel-arrow right" @click="nextCrowd">&nbsp;</div>
            </div>
            <!-- 轮播指示器 -->
            <div class="carousel-indicators">
              <span 
                v-for="(item, index) in crowdData" 
                :key="index"
                :class="['indicator', { active: index === currentCrowdIndex }]"
                @click="currentCrowdIndex = index"
              ></span>
            </div>
          </div>
          <!-- 无数据提示 -->
          <div class="crowd-info no-data" v-else>
            <div class="no-data-text">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'RightPanel',
  data() {
    return {
      currentSessionData: null,  // 当前届次数据
      monthlyChartType: 'participant',  // 月度统计图表类型: 'participant' 或 'attention'
      // DataV 轮播表格配置
      scrollBoardConfig: {
        header: [ '姓名', '项目', '参赛编号'],  // 表头
        data: [],  // 从后端获取
        index: false,                           // 不显示自动序号列
        columnWidth: [  300, 300, 300],       // 列宽: [序号, 场馆, 项目, 成绩]
        align: ['center', 'center', 'center'],    // 对齐方式
        rowNum: 3,                              // 显示行数
        headerBGC: 'rgba(15, 45, 75, 0.8)',     // 表头背景色: 深蓝色
        headerHeight: 24,                       // 表头高度
        oddRowBGC: 'transparent',               // 奇数行背景色: 透明
        evenRowBGC: 'rgba(79, 172, 254, 0.05)', // 偶数行背景色
        carousel: 'single',                     // 轮播模式: 单行
        waitTime: 2000                          // 轮播间隔: 2秒
      },
      // 人群数据 - 从后端获取
      crowdData: [],
      currentCrowdIndex: 0,  // 当前显示的人群索引
      crowdChartTimer: null,  // 人群占比饼图轮播定时器
      crowdChartIndex: 0,      // 人群占比饼图当前高亮索引
      lineChartTimer: null,   // 折线图轮播定时器
      lineChartIndex: 0,       // 折线图当前高亮索引
      // 新增：图表响应式适配相关
      lineResizeObserver: null,   // 折线图 ResizeObserver
      crowdResizeObserver: null,  // 人群占比饼图 ResizeObserver
      lineChart: null,            // 折线图实例
      crowdChart: null            // 人群占比饼图实例
    }
  },
  mounted() {
    // 使用 $nextTick 确保 DOM 已经渲染完成
    this.$nextTick(() => {
      // 页面加载完成后初始化图表
      this.initLineChart()   // 初始化折线图
      this.initCrowdChart()  // 初始化人群占比饼图
    })
    
    // 订阅届次切换事件
    EventBus.$on('session-changed', this.handleSessionChange)
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.crowdTimer) {
      clearInterval(this.crowdTimer)
    }
    if (this.crowdChartTimer) {
      clearInterval(this.crowdChartTimer)
    }
    if (this.lineChartTimer) {
      clearInterval(this.lineChartTimer)
    }
    
    // 新增：清理 ResizeObserver
    if (this.lineResizeObserver) {
      this.lineResizeObserver.disconnect()
      this.lineResizeObserver = null
    }
    if (this.crowdResizeObserver) {
      this.crowdResizeObserver.disconnect()
      this.crowdResizeObserver = null
    }
    
    // 新增：销毁图表实例
    if (this.lineChart) {
      this.lineChart.dispose()
      this.lineChart = null
    }
    if (this.crowdChart) {
      this.crowdChart.dispose()
      this.crowdChart = null
    }
    
    // 取消订阅届次切换事件，避免内存泄漏
    EventBus.$off('session-changed', this.handleSessionChange)
  },
  methods: {
    /**
     * 处理届次切换事件
     * @param {Object} payload - 事件载荷 { session: number|string, data: Object }
     */
    handleSessionChange(payload) {
      if (!payload || !payload.data) {
        console.error('届次切换事件数据无效')
        return
      }
      
      // 保存当前届次数据
      this.currentSessionData = payload.data
      
      // 更新所有图表和表格数据
      this.updateCharts()
    },
    
    /**
     * 更新所有图表和表格数据
     */
    updateCharts() {
      if (!this.currentSessionData) {
        return
      }
      
      // 更新月度数据统计折线图
      this.updateLineChart()
      
      // 更新场馆轮播表格
      this.updateScrollBoard()
      
      // 更新人群占比饼图
      this.updateCrowdChart()
      
      // 更新人群信息卡片数据
      this.updateCrowdData()
    },
    
    /**
     * 切换月度统计图表类型
     * @param {string} type - 'participant' 或 'attention'
     */
    switchMonthlyChartType(type) {
      if (this.monthlyChartType === type) {
        return
      }
      
      this.monthlyChartType = type
      this.updateLineChart()
    },
    
    /**
     * 更新月度数据统计折线图
     */
    updateLineChart() {
      const monthlyData = this.currentSessionData.monthlyData
      if (!monthlyData || !monthlyData.months) {
        console.error('月度数据格式不正确')
        return
      }
      
      // 根据当前选择的类型获取数据
      let data = []
      let yAxisName = ''
      
      if (this.monthlyChartType === 'participant') {
        if (!monthlyData.participants) {
          console.error('参赛人数数据不存在')
          return
        }
        data = monthlyData.participants
        yAxisName = '参赛人数（万）'
      } else {
        if (!monthlyData.attentions) {
          console.error('关注人次数据不存在')
          return
        }
        data = monthlyData.attentions
        yAxisName = '关注人次（万）'
      }
      
      // 使用保存的图表实例
      if (!this.lineChart) {
        return
      }
      
      // 更新图表配置
      this.lineChart.setOption({
        xAxis: {
          data: monthlyData.months
        },
        yAxis: {
          name: ''  // 不显示 Y 轴名称
        },
        series: [
          {
            name: yAxisName,  // 保留系列名称用于 tooltip
            data: data
          }
        ]
      })
      
      // 启动折线图轮播
      this.startLineChartCarousel()
    },
    
    /**
     * 启动折线图轮播
     * 每2秒自动高亮下一个数据点
     */
    startLineChartCarousel() {
      // 停止之前的轮播
      this.stopLineChartCarousel()
      
      if (!this.lineChart) {
        return
      }
      
      const option = this.lineChart.getOption()
      if (!option || !option.series || !option.series[0] || !option.series[0].data) {
        return
      }
      
      const dataLength = option.series[0].data.length
      if (dataLength === 0) {
        return
      }
      
      // 重置索引
      this.lineChartIndex = 0
      
      // 启动定时器
      this.lineChartTimer = setInterval(() => {
        // 移动到下一个
        this.lineChartIndex = (this.lineChartIndex + 1) % dataLength
        
        // 显示提示框
        this.lineChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.lineChartIndex
        })
      }, 2000)  // 每2秒切换一次
    },
    
    /**
     * 停止折线图轮播
     */
    stopLineChartCarousel() {
      if (this.lineChartTimer) {
        clearInterval(this.lineChartTimer)
        this.lineChartTimer = null
      }
      
      // 隐藏提示框
      if (this.lineChart) {
        this.lineChart.dispatchAction({
          type: 'hideTip'
        })
      }
    },
    
    /**
     * 更新场馆轮播表格
     */
    updateScrollBoard() {
      const venueScrollData = this.currentSessionData.venueScrollData
      if (!venueScrollData || !venueScrollData.header || !venueScrollData.data) {
        console.error('场馆数据格式不正确')
        return
      }
      
      // 更新表格配置
      this.scrollBoardConfig = {
        ...this.scrollBoardConfig,
        header: venueScrollData.header,
        data: venueScrollData.data
      }
    },
    
    /**
     * 更新人群占比饼图
     */
    updateCrowdChart() {
      const crowdDistribution = this.currentSessionData.crowdDistribution
      if (!crowdDistribution || !Array.isArray(crowdDistribution)) {
        console.error('人群占比数据格式不正确')
        return
      }
      
      // 使用保存的图表实例
      if (!this.crowdChart) {
        return
      }
      
      // 准备数据 - 使用实际参赛人数
      const data = crowdDistribution.map(item => ({
        name: item.name,
        value: parseInt(item.participant_count) || 0,  // 使用实际人数
        count: parseInt(item.participant_count) || 0   // 保存实际人数用于显示
      }))
      
      // 先停止轮播，避免在更新数据时触发 tooltip
      this.stopCrowdChartCarousel()
      
      // 计算总人数
      const total = data.reduce((sum, item) => sum + (item.count || 0), 0)
      
      // 格式化总数（添加千分位分隔符）
      const formattedTotal = total.toLocaleString()
      
      // 提取颜色
      const colors = crowdDistribution.map(item => item.color)
      
      // 更新图表配置
      this.crowdChart.setOption({
        color: colors,
        title: {
          subtext: formattedTotal  // 显示实际人数总和
        },
        tooltip: {
          formatter: function(params) {
            // 显示：名称 + 实际人数 + 百分比
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (params && params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name} <br/> ${count} (${params.percent}%)`
            }
            // 降级处理：只显示百分比
            return params && params.name ? `${params.name} ${params.percent || 0}%` : ''
          }
        },
        legend: {
          formatter: function(name) {
            const item = data.find(d => d.name === name)
            if (!item) return name
            const count = item.count.toLocaleString()
            // 计算百分比
            const percent = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0
            return '{name|' + name + '} {value|' + count + '}'
          }
        },
        series: [
          {
            data: data.map(item => ({
              name: item.name,
              value: item.value,  // 使用实际人数计算扇形大小
              count: item.count   // 保存实际人数用于显示
            }))
          },
          {
            data: [{ value: 1, itemStyle: { color: 'rgba(79, 172, 254, 0.2)' } }]
          },
          {
            data: [{ value: 1, itemStyle: { color: 'rgba(79, 172, 254, 0.3)' } }]
          }
        ]
      })
      
      // 数据更新完成后，延迟启动轮播，确保数据已完全渲染
      this.$nextTick(() => {
        setTimeout(() => {
          this.startCrowdChartCarousel()
        }, 100)
      })
    },
    
    /**
     * 启动人群占比饼图轮播
     * 每3秒自动高亮下一个扇形
     */
    startCrowdChartCarousel() {
      // 停止之前的轮播
      this.stopCrowdChartCarousel()
      
      if (!this.crowdChart) {
        return
      }
      
      const option = this.crowdChart.getOption()
      if (!option || !option.series || !option.series[0] || !option.series[0].data) {
        return
      }
      
      const dataLength = option.series[0].data.length
      if (dataLength === 0) {
        return
      }
      
      // 重置索引
      this.crowdChartIndex = 0
      
      // 启动定时器
      this.crowdChartTimer = setInterval(() => {
        // 取消上一个高亮
        this.crowdChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.crowdChartIndex
        })
        
        // 移动到下一个
        this.crowdChartIndex = (this.crowdChartIndex + 1) % dataLength
        
        // 高亮当前
        this.crowdChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: this.crowdChartIndex
        })
        
        // 显示提示框（跟随扇形，但限制范围）
        this.crowdChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: this.crowdChartIndex
        })
      }, 3000)  // 每3秒切换一次
    },
    
    /**
     * 停止人群占比饼图轮播
     */
    stopCrowdChartCarousel() {
      if (this.crowdChartTimer) {
        clearInterval(this.crowdChartTimer)
        this.crowdChartTimer = null
      }
      
      // 取消所有高亮
      if (this.crowdChart) {
        this.crowdChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0
        })
      }
    },
    
    /**
     * 更新人群信息卡片数据
     */
    updateCrowdData() {
      const focusGroup = this.currentSessionData.focusGroup
      if (!focusGroup) {
        console.error('重点人群数据格式不正确')
        return
      }
      
      // 从 crowdDistribution 构建人群数据
      const crowdDistribution = this.currentSessionData.crowdDistribution
      if (!crowdDistribution || !Array.isArray(crowdDistribution)) {
        return
      }
      
      // 计算总参赛人数
      const overview = this.currentSessionData.overview
      const totalParticipants = overview ? overview.totalParticipants : 0
      
      // 更新人群数据（根据百分比计算实际人数）
      this.crowdData = crowdDistribution.map((item, index) => {
        const count = Math.round(totalParticipants * item.value / 100)
        const ageRanges = ['0-6岁', '7-17岁', '18-35岁', '36-59岁', '60岁以上']
        const icons = ['👶', '🧒', '👨', '👴', '👵']
        
        return {
          icon: icons[index] || '👤',
          label: item.name,
          age: ageRanges[index] || '',
          count: count
        }
      })
      
      // 重置轮播索引
      this.currentCrowdIndex = 0
      
      // 重新启动轮播
      this.startCrowdCarousel()
    },
    
    /**
     * 初始化每月数据统计折线图
     * 特点: 面积填充 + 平滑曲线 + 渐变色
     */
    initLineChart() {
      // 获取 DOM 元素并初始化 ECharts 实例
      this.lineChart = this.$echarts.init(document.getElementById('lineChart'))
      const option = {
        // 鼠标悬停提示框配置
        tooltip: {
          trigger: 'axis',                      // 触发类型: 坐标轴触发
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#4facfe',
          borderWidth: 1,
          padding: [4, 8],                      // 缩小内边距
          textStyle: {
            color: '#fff',
            fontSize: 11                        // 缩小字体
          }
        },
        // 图例配置
        legend: {
          data: ['参赛人数（万）', '关注人次（万）'],
          textStyle: {
            color: '#8c8c8c'
          },
          top: 10,
        },

        // 图表网格配置 (控制图表位置和大小)
        grid: {
          left: '8%',                           // 左边距
          right: '5%',                          // 右边距
          bottom: '8%',                         // 下边距
          top: '15%',                           // 上边距
          containLabel: true                    // 包含坐标轴标签
        },
        // X 轴配置
        xAxis: {
          type: 'category',                     // 类目轴
          data: [],  // 从后端获取
          axisLabel: {                          // 轴标签
            color: '#8c8c8c',
            fontSize: 11
          },
          axisLine: {                           // 轴线
            lineStyle: {
              color: '#2a4a6a'
            }
          },
          axisTick: {                           // 刻度线
            show: false
          }
        },
        // Y 轴配置
        yAxis: {
          type: 'value',                        // 数值轴
          name: '',                             // 初始为空，由 updateLineChart 动态设置
          nameTextStyle: {
            color: '#8c8c8c',
            fontSize: 11
          },
          axisLabel: {
            color: '#8c8c8c',
            fontSize: 11
          },
          axisLine: {
            show: false                         // 不显示轴线
          },
          splitLine: {                          // 分隔线
            lineStyle: {
              color: '#2a4a6a',
              type: 'dashed'                    // 虚线
            }
          }
        },
        series: [
          {
            name: '',                           // 初始为空，由 updateLineChart 动态设置
            type: 'line',                       // 折线图
            data: [],  // 从后端获取
            smooth: 0,                       // 平滑曲线
            symbol: 'circle',                   // 数据点形状: 圆形
            symbolSize: 6,                      // 数据点大小
            areaStyle: {                        // 面积填充样式
              color: {
                type: 'linear',                 // 线性渐变
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(255, 77, 79, 0.6)' },   // 顶部: 红色 60% 透明度
                  { offset: 1, color: 'rgba(255, 77, 79, 0.05)' }   // 底部: 红色 5% 透明度
                ]
              }
            },
            lineStyle: {                        // 线条样式
              width: 2,
              color: '#ff4d4f'                  // 红色
            },
            itemStyle: {                        // 数据点样式
              color: '#ff4d4f',
              borderColor: '#fff',              // 白色边框
              borderWidth: 2
            }
          }
        ]
      }
      // 应用配置
      this.lineChart.setOption(option)
      
      // 新增：使用 ResizeObserver 监听容器尺寸变化
      const chartDom = document.getElementById('lineChart')
      if (chartDom) {
        if (typeof ResizeObserver !== 'undefined') {
          // 使用防抖避免 ResizeObserver loop 错误
          let resizeTimeout = null
          this.lineResizeObserver = new ResizeObserver(() => {
            if (resizeTimeout) {
              clearTimeout(resizeTimeout)
            }
            resizeTimeout = setTimeout(() => {
              this.handleLineResize()
            }, 100)
          })
          this.lineResizeObserver.observe(chartDom)
        } else {
          // 降级方案：使用 window.resize 事件
          console.warn('ResizeObserver 不支持，使用 window.resize 降级方案')
          window.addEventListener('resize', this.handleLineResize)
        }
      }
    },
    
    /**
     * 初始化人群占比环形饼图
     * 特点: 三层结构 (主饼图 + 内边框 + 外边框) + 中心文字 + 右侧图例
     */
    initCrowdChart() {
      // 获取 DOM 元素并初始化 ECharts 实例
      this.crowdChart = this.$echarts.init(document.getElementById('crowdChart'))
      
      // 检测是否为移动端
      const isMobile = window.innerWidth < 768
      
      const option = {
        // 饼图颜色方案 (5种颜色对应5个年龄段)
        color: ['#00d4ff', '#52c41a', '#ffd700', '#ff6b6b', '#bce672'],
        // 鼠标悬停提示框配置
        tooltip: {
          trigger: 'item',                      // 触发类型: 数据项触发
          formatter: function(params) {
            // 添加严格的数据验证，防止偶发的 undefined 错误
            if (!params || !params.name) return ''
            if (params.data && typeof params.data.count === 'number') {
              const count = params.data.count.toLocaleString()
              return `${params.name} <br/> ${count} (${params.percent || 0}%)`
            }
            return `${params.name} ${params.percent || 0}%`
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // 背景色
          borderColor: '#4facfe',               // 边框色
          borderWidth: 1,
          padding: [4, 8],                      // 内边距 [上下, 左右] - 缩小
          textStyle: {
            color: '#fff',                      // 文字颜色
            fontSize: 11                        // 字体大小 - 缩小
          },
          confine: true,                        // 限制在图表区域内
          position: function(point, params, dom, rect, size) {
            // 智能定位：跟随扇形但限制范围
            const x = point[0]
            const y = point[1]
            const boxWidth = size.contentSize[0]
            const boxHeight = size.contentSize[1]
            const viewWidth = size.viewSize[0]
            const viewHeight = size.viewSize[1]
            
            // 默认偏移量（较小，避免溢出）
            let posX = x + 15
            let posY = y + 15
            
            // 如果右侧空间不够，显示在左侧
            if (posX + boxWidth > viewWidth - 10) {
              posX = x - boxWidth - 15
            }
            
            // 如果下方空间不够，显示在上方
            if (posY + boxHeight > viewHeight - 10) {
              posY = y - boxHeight - 15
            }
            
            // 确保不超出边界
            posX = Math.max(10, Math.min(posX, viewWidth - boxWidth - 10))
            posY = Math.max(10, Math.min(posY, viewHeight - boxHeight - 10))
            
            return [posX, posY]
          }
        },
        // 中心文字配置 (显示在饼图中心)
        title: {
          text: '总数',                         // 主标题
          subtext: '0',                         // 副标题 (数值) - 初始为0
          textStyle: {
            color: 'rgba(255, 255, 255, 0.45)',
            fontSize: 11,
            fontWeight: 'normal'
          },
          subtextStyle: {
            fontSize: 13,                       // 数值字号
            color: '#4facfe',
            fontWeight: 'bold'
          },
          left: isMobile ? '50%' : '31%',      // 移动端居中，桌面端偏左
          top: '39%',                          // 垂直居中
          textAlign: 'center',
          textVerticalAlign: 'middle'
        },
        // 图例配置 (显示在右侧) - 问题 4: 移动端隐藏图例
        legend: {
          show: !isMobile,                      // 移动端隐藏图例
          orient: 'vertical',                   // 垂直排列
          top: 'middle',                        // 垂直居中
          right: '5%',                          // 距离右侧 5%
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          icon: 'circle',                       // 图标形状: 圆形
          itemWidth: 8,                         // 图标宽度
          itemHeight: 8,                        // 图标高度
          itemGap: 8,                          // 图例项间距
          // 自定义图例文本格式: 名称 + 百分比
          formatter: function(name) {
            return name
          },
          textStyle: {
            rich: {                             // 富文本样式
              name: {                           // 名称样式
                color: 'rgba(255, 255, 255, 0.45)',
                fontSize: 12,
                width: 40
              },
              value: {                          // 百分比样式
                color: '#4facfe',
                fontSize: 12,
                fontWeight: 'bold'
              }
            }
          }
        },
        series: [
          // ========== 第一层: 主饼图 ==========
          {
            radius: isMobile ? ['40%', '65%'] : ['50%', '75%'],  // 移动端调整半径
            center: isMobile ? ['50%', '50%'] : ['32%', '50%'],  // 移动端居中
            type: 'pie',
            label: {
              show: true,                       // 显示标签
              formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',                // 标签格式: 名称 + 分隔线 + 百分比 (三行显示)
              rich: {                           // 富文本样式
                b: {                            // 名称样式
                  fontSize: isMobile ? 10 : 12,
                  color: 'rgba(255, 255, 255, 0.45)',
                  align: 'left',
                  padding: 4
                },
                hr: {                           // 分隔线样式
                  borderColor: 'rgba(255, 255, 255, 0.45)',       // 青色分隔线
                  width: '100%',
                  borderWidth: 1,
                  height: 0
                },
                d: {                            // 百分比样式
                  fontSize: isMobile ? 10 : 12,
                  color: '#4facfe',             // 青色百分比
                  align: 'left',
                  padding: 4,
                  fontWeight: 'bold'
                }
              },
              fontSize: isMobile ? 10 : 12,     // 标签字号
              color: 'rgba(255, 255, 255, 0.45)',                    // 标签颜色
              position: 'outside'               // 标签位置: 外侧
            },
            labelLine: {                        // 标签引导线
              show: true,
              length: isMobile ? 5 : 10,        // 移动端缩短引导线
              length2: isMobile ? 10 : 20,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
                width: 1
              }
            },
            data: [],                           // 数据源 - 从后端获取
            emphasis: {                         // 鼠标悬停效果
              scale: true,                      // 启用缩放
              scaleSize: 10,                    // 缩放大小（像素）- 更明显的高亮效果
              itemStyle: {
                shadowBlur: 20,                 // 增强阴影
                shadowOffsetX: 0,
                shadowColor: 'rgba(79, 172, 254, 0.8)',
                borderColor: '#fff',            // 白色边框
                borderWidth: 2                  // 边框宽度
              }
            }
          },
          // ========== 第二层: 内边框 ==========
          {
            radius: isMobile ? ['38%', '40%'] : ['48%', '50%'],  // 移动端调整
            center: isMobile ? ['50%', '50%'] : ['32%', '50%'],  // 移动端居中
            type: 'pie',
            label: {
              show: false                       // 不显示标签
            },
            labelLine: {
              show: false                       // 不显示引导线
            },
            animation: false,                   // 关闭动画
            tooltip: {
              show: false                       // 不显示提示框
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: 'rgba(79, 172, 254, 0.2)' // 半透明青色
                }
              }
            ]
          },
          // ========== 第三层: 外边框 ==========
          {
            type: 'pie',
            clockWise: false,                   // 逆时针
            hoverAnimation: false,              // 关闭悬停动画
            center: isMobile ? ['50%', '50%'] : ['32%', '50%'],  // 移动端居中
            radius: isMobile ? ['67%', '68%'] : ['77%', '78%'],  // 移动端调整
            label: {
              show: false
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: 'rgba(79, 172, 254, 0.3)' // 半透明青色
                }
              }
            ]
          }
        ]
      }
      
      // 应用配置
      this.crowdChart.setOption(option)
      
      // 新增：使用 ResizeObserver 监听容器尺寸变化
      const chartDom = document.getElementById('crowdChart')
      if (chartDom) {
        if (typeof ResizeObserver !== 'undefined') {
          // 使用防抖避免 ResizeObserver loop 错误
          let resizeTimeout = null
          this.crowdResizeObserver = new ResizeObserver(() => {
            if (resizeTimeout) {
              clearTimeout(resizeTimeout)
            }
            resizeTimeout = setTimeout(() => {
              this.handleCrowdResize()
            }, 100)
          })
          this.crowdResizeObserver.observe(chartDom)
        } else {
          // 降级方案：使用 window.resize 事件
          console.warn('ResizeObserver 不支持，使用 window.resize 降级方案')
          window.addEventListener('resize', this.handleCrowdResize)
        }
      }
    },
    
    /**
     * 启动人群信息轮播
     * 每3秒自动切换到下一个年龄段
     */
    startCrowdCarousel() {
      // 只有在有数据时才启动轮播
      if (!this.crowdData || this.crowdData.length === 0) {
        return
      }
      
      // 清除之前的定时器
      if (this.crowdTimer) {
        clearInterval(this.crowdTimer)
      }
      
      this.crowdTimer = setInterval(() => {
        this.currentCrowdIndex = (this.currentCrowdIndex + 1) % this.crowdData.length
      }, 3000)  // 每3秒切换一次
    },
    
    /**
     * 上一个年龄段
     */
    prevCrowd() {
      this.currentCrowdIndex = (this.currentCrowdIndex - 1 + this.crowdData.length) % this.crowdData.length
    },
    
    /**
     * 下一个年龄段
     */
    nextCrowd() {
      this.currentCrowdIndex = (this.currentCrowdIndex + 1) % this.crowdData.length
    },
    
    /**
     * 新增：处理折线图容器尺寸变化
     */
    handleLineResize() {
      try {
        if (this.lineChart) {
          this.lineChart.resize()
        }
      } catch (error) {
        console.error('折线图重绘失败:', error)
        // 尝试重新初始化图表
        this.$nextTick(() => {
          try {
            this.initLineChart()
            // 如果有当前届次数据，重新更新图表
            if (this.currentSessionData) {
              this.updateLineChart()
            }
          } catch (reinitError) {
            console.error('折线图重新初始化失败:', reinitError)
          }
        })
      }
    },
    
    /**
     * 新增：处理人群占比饼图容器尺寸变化
     */
    handleCrowdResize() {
      try {
        if (this.crowdChart) {
          this.crowdChart.resize()
        }
      } catch (error) {
        console.error('人群占比饼图重绘失败:', error)
        // 尝试重新初始化图表
        this.$nextTick(() => {
          try {
            this.initCrowdChart()
            // 如果有当前届次数据，重新更新图表
            if (this.currentSessionData) {
              this.updateCrowdChart()
            }
          } catch (reinitError) {
            console.error('人群占比饼图重新初始化失败:', reinitError)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.panel-item {
  flex: 1;
  min-height: 0; // 允许 flex 子项缩小
  
  &.monthly-panel {
    flex: 0 0 50%;  // 每月数据统计模块固定占 50% 高度
    
    .panel-box {
      background: url('~@/assets/images/每月数据统计的背景图.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
  
  &.crowd-panel {
    flex: 0 0 50%;  // 人群占比模块固定占 50% 高度
    
    .panel-box {
      background: url('~@/assets/images/人群占比模块的背景图.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
}

.panel-box {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  position: relative;
}

.panel-content {
  padding: 15px 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background: url('~@/assets/images/tyu.png') no-repeat;
  background-position: right 2.8vh;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-wrap: nowrap;
  z-index: 1;
  padding: 12px 10px 8px 20px; // 修复问题 1: 增加上下内边距，避免文字超出边框
  background: url('~@/assets/images/标题背景.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 4px;
  margin-top: 0px;
}

.panel-title {
  font-size: 1rem;
  font-weight: bold;
  color: #E2E2E2;
  position: relative;
  padding-left: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background: linear-gradient(to bottom, #4facfe, #00f2fe);
    border-radius: 2px;
  }
}

.divider-line {
  width: 100%;
  height: 2px;
  background: url('~@/assets/images/分割线.png') no-repeat center center;
  background-size: 100% 100%;
}

.panel-tabs {
  display: flex;
  gap: 8px;
  z-index: 1;
  margin-right: 55px;
  
  .tab {
    padding: 3px 16px;
    font-size: 12px;
    color: #8c8c8c;
    cursor: pointer;
    border: 1px solid rgba(79, 172, 254, 0.3);
    border-radius: 15px;
    transition: all 0.3s;
    white-space: nowrap;
    background: transparent;
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(79, 172, 254, 0.2), transparent);
      transition: left 0.5s;
    }
    
    &.active {
      color: #fff;
      border-color: #4facfe;
      background: transparent;
      box-shadow: 0 0 10px rgba(79, 172, 254, 0.5);
      font-weight: bold;
      
      &::before {
        left: 100%;
      }
    }
    
    &:hover:not(.active) {
      color: #4facfe;
      border-color: #4facfe;
      background: transparent;
    }
  }
}

.chart-container {
  width: 100%;
  height: 30vh;
  min-height: 0;
}

// 修复问题 2: 人群占比饼图高度缩小
.crowd-chart-container {
  height: 22vh; // 从 30vh 缩小到 22vh
  flex-shrink: 0; // 防止被压缩
}

.section-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: bold;
  padding: 10px 10px 10px 10px;
  text-align: center;
  margin-top: 5px;
  background: url('~@/assets/images/联合 28.png') no-repeat center center;
  background-size: contain;
}

.scroll-table {
  margin-top: 0px;
  
  ::v-deep .dv-scroll-board {
    .header {
      font-size: 11px;
      font-weight:normal;
      color: rgba(255, 255, 255, 0.55);
    }
    
    .rows {
      .row-item {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.45);
        transition: all 0.3s;
        
        &:hover {
          background: rgba(79, 172, 254, 0.15) !important;
        }
      }
      
      .ceil {
        padding: 0 5px;
      }
    }
    
    .index {
      background: linear-gradient(135deg, #4facfe, #00f2fe);
      border-radius: 3px;
      color: #fff;
      font-weight: bold;
    }
  }
}

.crowd-info {
  flex: 2;  // 信息展示区占 40% (2/5)
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0.9375rem;
  
  &.no-data {
    .no-data-text {
      color: rgba(255, 255, 255, 0.45);
      font-size: 14px;
      text-align: center;
    }
  }
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.carousel-arrow {
  font-size: 32px;
  color: rgba(79, 172, 254, 0.5);
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
  padding: 0 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;
  
  &.left {
    background: url('~@/assets/images/轮播之时器的左背景图.png') no-repeat center center;
    background-size: contain;
  }
  
  &.right {
    background: url('~@/assets/images/轮播之时器的右背景图.png') no-repeat center center;
    background-size: contain;
  }
  
  &:hover {
    color: #4facfe;
    transform: scale(1.2);
  }
  
  &:active {
    transform: scale(0.9);
  }
}

.info-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 20px;
  background: url('~@/assets/images/轮播指示器单个的背景图.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 8px;
  border: 1px solid rgba(79, 172, 254, 0.3);
  flex: 1;
  min-height: 40px;
}

.info-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(79, 172, 254, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 15px rgba(79, 172, 254, 0.3);
  
  img {
    width: 65px;
    height: 65px;
    object-fit: contain;
  }
}

.info-text {
  flex: 1;
}

.info-label {
  font-size: 0.875rem;
  color: #4facfe;
  margin-bottom: 8px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-value {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.45);
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.carousel-indicators {
  display: flex;
  gap: 6px;
  margin-top: 0px;
}

.indicator {
  width: 20px;
  height: 6px;
  border-radius: 3px;
  background: url('~@/assets/images/轮播指示器单个的背景图.png') no-repeat center center;
  background-size: contain;
  opacity: 0.3;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    opacity: 0.6;
  }
  
  &.active {
    width: 20px;
    opacity: 1;
  }
}

// 轮播动画
.slide-fade-enter-active {
  transition: all 0.4s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

// 移动端样式优化
@media (max-width: 767px) {
  .panel-item {
    &.monthly-panel {
      flex: 0 0 auto;  // 自动高度
      min-height: 450px;
    }

    &.crowd-panel {
      flex: 0 0 auto;  // 自动高度
      min-height: 400px;
    }
  }

  .chart-container {
    min-height: 250px;  // 确保图表有足够的高度
    height: 250px;
  }

  .panel-content {
    padding: 10px;
  }

  .panel-title {
    font-size: 14px;
  }

  // 问题 3: 切换按钮样式优化 - 降低高度
  .panel-tabs {
    gap: 6px;
    margin-right: 30px;

    .tab {
      padding: 4px 10px;
      font-size: 11px;
      border-radius: 10px;
      background: rgba(15, 45, 75, 0.6);
      border: 1px solid rgba(79, 172, 254, 0.4);
      min-height: 28px;
      display: flex;
      align-items: center;
      
      &.active {
        background: linear-gradient(135deg, rgba(79, 172, 254, 0.3), rgba(0, 242, 254, 0.3));
        border-color: #4facfe;
        box-shadow: 0 0 8px rgba(79, 172, 254, 0.4);
      }
    }
  }

  .info-label,
  .info-value {
    font-size: 12px;
  }

  .carousel-arrow {
    width: 35px;
    height: 35px;
  }
}
</style>
